import axios from "axios";
import { createAsyncThunk,createSlice } from "@reduxjs/toolkit";

export const STATUSES = Object.freeze({
    IDLE : 'idle',
    ERROR:'error',
    LOADING: 'loading',
});

const getVerifyHorseAssociationSlice = createSlice({
    name: 'VerifyHorseAssociation',
    initialState: {
        data:[],
        status : STATUSES.IDLE,
    },

    extraReducers: (builder) => {
        builder
        .addCase(fetchVerifyHorseAssociation.pending, (state, action) => {
            state.status = STATUSES.LOADING;
        })
        .addCase(fetchVerifyHorseAssociation.fulfilled, (state, action) => {
            state.data = action.payload;
            state.status = STATUSES.IDLE
        }) 
        .addCase(fetchVerifyHorseAssociation.rejected , (state,action) => {
            state.status = STATUSES.ERROR;
        })
    }
});

export const {setVerifyHorseAssociation , setStatus} = getVerifyHorseAssociationSlice.actions;
export default getVerifyHorseAssociationSlice.reducer;

export const fetchVerifyHorseAssociation = createAsyncThunk('/VerifyHorseAssociationget/fetch', async({id}) => {
    const res = await axios.get(`${window.env.API_URL}/VerifyHorseAssociation/${id}`);
    const VerifyHorseAssociationData = res.data;
    return VerifyHorseAssociationData.data;
})